import { render } from "./projetos.vue?vue&type=template&id=5aaa89bb"
import script from "./projetos.vue?vue&type=script&lang=js"
export * from "./projetos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__